// React imports

import React from "react";

// Bootstrap imports

import { Card } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";

// Custom-defined component imports

import Topbar from "../components/Topbar";
import TxtToImg from "../components/Generator/TxtToImg";
import StyleSelector from "../components/Generator/StyleSelector";
import PromptSuggestions from "../components/Generator/PromptSuggestions";
import ImgToImg from "../components/Generator/ImgToImg";
import InPainting from "../components/Generator/InPainting";
import GoBackLink from "../components/GoBackLink";

// Styling
import "../css/AIArtPage.css";

// Page component that hosts AI Art expedition

// Main sections: Prompt panel, Generator panel, Styles panel

// Styling from Bootstrap components and CSS rules in /frontend/src/App.css

class AIArt extends React.Component {
  
  // Constructor
  // 'selected' refers to selected generation mode

  constructor(props) {
    super(props);
    this.state = {
      selected: "Text-To-Image",
    };
  }

  // Set selected generation mode (text-to-image, image-to-image, inpainting)

  handleDropdownSelect = (eventKey) => {
    this.setState({ selected: eventKey });
  };

  // AI Art expedition page JSX

  render() {
    return (
      <div className="page">
        {/* Navbar */}
        <Topbar isExplorePage={true} /> {/* AI Art page is "child" of Explore page */}
        <GoBackLink pageName = "Explore" pageLink = "/explore" />
        {/* Container for all elements below navbar */}
        <Container fluid id="ai-main">
          {/* Container for all panels */}
          <Row id="ai-panelarea">
            <Col md={{ span: 3, offset: 0 }}>
              {/* Prompt panel */}
              <PromptSuggestions />
            </Col>
            <Col md={{ span: 6, offset: 0 }}>
              {/* Generator panel */}
              <Card id="generator-panel">
                {/* Generator panel header */}
                <Card.Header id="generator-header" className="light-purple white-text">
                  Generator
                  {/* Mode dropdown: Text-to-Image, Image-to-Image, Inpainting */}
                  <div>
                    Mode:
                    <Dropdown
                      onSelect={this.handleDropdownSelect}
                    >
                      <Dropdown.Toggle
                        className="blue button"
                        id="dropdown-basic"
                        title={this.state.selected || "Select a value"}
                      >
                        {this.state.selected || "Select a value"}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item eventKey="Text-To-Image">
                          Text-To-Image
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="Image-To-Image">
                          Image-To-Image
                        </Dropdown.Item>
                        {/* <Dropdown.Item eventKey="Inpainting">Inpainting</Dropdown.Item> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Card.Header>
                {/* Generator body */}
                <Card.Body id="generator-body">
                  {/* Mode-specific generator elements */}
                  {/* If Text-to-Image has been selected in the mode dropdown,
                      display text-to-image elements, and so on */}
                  {this.state.selected === "Text-To-Image" ? (
                    <TxtToImg />
                  ) : this.state.selected === "Image-To-Image" ? (
                    <ImgToImg />
                  ) : this.state.selected === "Inpainting" ? (
                    <InPainting />
                  ) : null}
                </Card.Body>
              </Card>
            </Col>
            <Col md={{ span: 3, offset: 0 }}>
              {/* Style panel */}
              <StyleSelector />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default AIArt;
